<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div style="position:absolute; top:10px; right:10px; z-index:9;">
          <vs-button
            :href="event_url"
            target="_blank"
            color="primary"
            type="flat"
            >Go to Event <i class="ml-2 fas fa-external-link-alt"></i
          ></vs-button>
        </div>

        <!-- START TABS -->
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Event">
            <table
              v-if="event != null"
              id="zebra"
              width="100%"
              class="table table-bordered table-striped"
            >
              <tr v-for="(item, index) in eventData" :key="index">
                <td width="200">
                  <strong>{{ item.title }}</strong>
                </td>
                <td>
                  <img
                    v-if="item.type == 'image'"
                    :src="event[item.key]"
                    width="200px"
                  />
                  <div
                    v-else-if="item.type == 'html'"
                    v-html="event[item.key]"
                  ></div>
                  <div v-else>{{ event[item.key] }}</div>
                </td>
              </tr>
            </table>
          </vs-tab>
          <vs-tab label="Ticket">
            <div v-if="products != null">
              <!-- <vs-row> -->
                <!-- <vs-col
                  v-for="(product, index) in products"
                  :key="index"
                  vs-lg="6"
                  vs-sm="12"
                  class="m-0 p-2"
                > -->
                <div
                  v-for="(product, index) in products"
                  :key="index"
                  vs-lg="6"
                  vs-sm="12"
                  class="m-0 p-2"
                >
                  <h3>Type {{ index + 1 }}</h3>

                  <div>
                    <table
                      v-if="product != null"
                      id="zebra"
                      width="100%"
                      class="table table-bordered table-striped"
                    >
                      <tr v-for="(item, i) in productData" :key="i">
                        <template v-if="item.key == 'promo_price'">
                          <td colspan="2">
                            <strong>{{ item.title }}</strong>
                            <table
                              width="100%"
                              class="table table-bordered table-striped"
                            >
                              <tr>
                                <td>ID</td>
                                <td>Promo</td>
                                <td>Description</td>
                                <td>Value</td>
                                <td>Type</td>
                                <td>Discount from</td>
                                <td>Price</td>
                                <td>Start</td>
                                <td>End</td>
                                <td>Note</td>
                              </tr>
                              <tr
                                v-for="(promo, i) in product['t_promocount']"
                                :key="i"
                              >
                                <td>
                                  {{ promo.promo_id }}
                                </td>
                                <td>
                                  {{ promo.promotitle }}
                                </td>
                                <td>
                                  {{ promo.promodesc }}
                                </td>
                                <td>
                                  {{ promo.discvalue }}
                                </td>
                                <td>
                                  {{ promo.disctype }}
                                </td>
                                <td>{{ promo.discfrom }}</td>
                                <td>
                                  {{ promo.promoprice }}
                                </td>
                                <td>
                                  {{ promo.promodate_start }}
                                </td>
                                <td>
                                  {{ promo.promodate_end }}
                                </td>
                                <td>
                                  {{ promo.promonote }}
                                </td>
                              </tr>
                            </table>
                          </td>
                        </template>
                        <template v-else>
                          <td width="200">
                            <strong>{{ item.title }}</strong>
                          </td>
                          <td>
                            {{ product[item.key] }}
                            <img
                              v-if="item.type == 'image'"
                              :src="product[index]"
                              width="200px"
                            />
                            <div
                              v-else-if="item.type == 'html'"
                              v-html="product[index]"
                            ></div>
                            <div v-else>{{ product[index] }}</div>
                          </td>
                        </template>
                      </tr>
                    </table>
                  </div>
                <!-- </vs-col> -->
                </div>
              <!-- </vs-row> -->
            </div>
          </vs-tab>
          <vs-tab label="Seller">
            <table
              v-if="event != null"
              id="zebra"
              width="100%"
              class="table table-bordered table-striped"
            >
              <tr v-for="(item, index) in sellerData" :key="index">
                <td width="200">
                  <strong>{{ item.title }}</strong>
                </td>
                <td>
                  <img
                    v-if="item.type == 'image'"
                    :src="merchant[item.key]"
                    width="200px"
                  />
                  <div
                    v-else-if="item.type == 'html'"
                    v-html="merchant[item.key]"
                  ></div>
                  <div v-else>{{ merchant[item.key] }}</div>
                </td>
              </tr>
            </table>
          </vs-tab>
          <vs-tab label="Script">
            <div v-if="event != null">
              <div
                id="script"
                style="font-size: 16px; line-height:24px; margin-right: 40%;"
              >
                <h2>
                  <small>Communication Scripts </small><br />{{
                    event.pro_title
                  }}
                </h2>
                <h3>Follow-up Call Script</h3>
                <p>Hi, am I speaking with **Customer Name**</p>
                <p>
                  My name is **Name of Staff**, I’m calling from SoldOutt - we
                  handle ticket sales for
                  <strong
                    >Citi Live: How to enable your business growth in a
                    post-COVID world</strong
                  >, thank you for your interest in our festival. I notice that
                  you made a booking of **Number** **Ticket Type** tickets, is
                  that right?
                </p>
                <p>
                  I see you haven't made a payment yet. I'm calling you to
                  assist you in case you have any payment issues. Is there
                  anything else I can help you with?
                </p>
                <p><em>Wait for the answer...</em></p>
                <p>----</p>
                <p>In case the buyer says there’s an issue and need help</p>
                <p>
                  May I know:<br />
                  - Which bank card are you using? Which is the country is this
                  card from?
                </p>
                <p>
                  - Can you explain what the issue was? Do you remember what the
                  error was?
                </p>
                <p>
                  Would you like to try it again while I’m on the call with you
                  so I can assist you.
                </p>
                <p><em>If yes.. walkthrough the process with the buyer</em></p>
                <p>
                  <em>If no…<br /> </em>OK no worries, thank you for sharing the
                  details. Let me share this with our tech team and look into it
                  immediately. We will call you again to update and assist you
                  with the payment.
                </p>
                <p>
                  Apart from this, Is there anything else you would like us to
                  help you with?
                </p>
                <p>Thank you. We’ll get back to you as soon as possible.</p>
                <p>
                  <strong class="text-danger"
                    >Inform Dave and team in the LINE Group</strong
                  >
                </p>
                <p>----</p>
                <p>In case the buyer says no issue</p>
                <p>
                  <em
                    >Wait for the buyer to say it him/herself why he’s not
                    making the payment</em
                  >
                </p>
                <p><em>If he says it...keep a note of it</em></p>
                <p><em>If he doesn’t say it...</em></p>
                <p>
                  If you don't have any payment issue that's great to hear.. for
                  feedback to help improve our experience, is there a reason why
                  you haven't paid yet? Can you share this with us so we can
                  help you decide as well?
                </p>
                <p><em>Keep note… Once the reason is received..</em></p>
                <p>
                  Thanks for sharing your feedback with us. Feel free to reach
                  out to us if you have any further questions or require any
                  assistance at help@soldoutt.com (sold out with a double "T").
                  Have a great day. Bye-bye"
                </p>

                <br /><br />

                <h3>Follow-up Email Script</h3>
                <p><b>Don’t forget!</b> CC these emails:</p>
                <div class="copybtn">
                  <button class="c2c" data-clipboard-target="#cctext">
                    <i class="fa fa-clipboard" aria-hidden="true"></i> Copy CC
                  </button>
                </div>
                <pre
                  id="cctext"
                  style="white-space: pre-wrap; padding-right: 140px;"
                >
help@soldoutt.com, dave@soldoutt.com, ticket@soldoutt.com</pre
                >
                <br /><br />
                <p>Subject</p>
                <div class="copybtn">
                  <button class="c2c" data-clipboard-target="#subjecttext">
                    <i class="fa fa-clipboard" aria-hidden="true"></i> Copy
                    Subject
                  </button>
                </div>
                <pre
                  id="subjecttext"
                  style="white-space: pre-wrap; padding-right: 140px;"
                >
Your Citi Live: How to enable your business growth in a post-COVID world booking
</pre
                >
                <br /><br />
                <p>Message</p>
                <div class="copybtn">
                  <button class="c2c" data-clipboard-target="#messagetext">
                    <i class="fa fa-clipboard" aria-hidden="true"></i> Copy
                    Message
                  </button>
                </div>
                <pre
                  id="messagetext"
                  style="white-space: pre-wrap; padding-right: 140px;"
                >
Hi **Customer Firstname**,

My name is **Name of Staff**. I’m from the support team at SoldOutt - the official ticketing platform for Citi Live: How to enable your business growth in a post-COVID world.

I'm just reaching out to you to provide assistance with your ticket booking.

I see that you made a booking for **Quantity** **Type of Ticket** tickets but you haven’t made the payment yet. Is there anything I can help you with confirming this booking?

In case you’re looking for the payment link, here it is:
**Pay Link**

Or if you require any assistance or have any questions or concerns, please let me know. We're happy to assist you.

Looking forward to seeing you at Citi Live: How to enable your business growth in a post-COVID world!

Cheers,
**Name of Staff**
Ticketing Support
SoldOutt
www.soldoutt.com
</pre
                >
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Promocode"> </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>
  </div>
</template>
<script>
import moment from "moment-timezone";
import { mapState } from "vuex";

import Service from "@/services";

export default {
  components: {},
  props: ["folder"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      }
    })
  },
  data() {
    return {
      activeTab: 0,
      event: null,
      merchant: null,
      products: null,
      event_url: "",
      eventData: [
        { title: "Status", key: "sell_status" },
        { title: "Event ID", key: "event_id" },
        { title: "Name", key: "pro_title" },
        { title: "Shortname", key: "pro_name" },
        { title: "Type", key: "pro_type" },
        { title: "Start Date & Time", key: "datetime" },
        { title: "Date", key: "date" },
        { title: "Time", key: "time" },
        { title: "End Date & Time", key: "datetime_end" },
        { title: "Venue", key: "venue" },
        { title: "Quantity", key: "quantity" },
        { title: "Sold", key: "sold" },
        { title: "Remaining", key: "remaining" },
        { title: "Poster", key: "poster", type: "image" },
        { title: "Background Color", key: "bgcolor" },
        { title: "Background Image", key: "bgimg", type: "image" },
        { title: "Text Color", key: "txtcolor" },
        { title: "Short URL", key: "shorturl" },
        { title: "Ticket Price", key: "" },
        { title: "Full Price", key: "" },
        { title: "Early Bird Price", key: "" },
        { title: "Early Bird Deadline", key: "" },
        { title: "English Name Only", key: "" },
        { title: "Landing Page", key: "landingpage" },
        { title: "Support No.", key: "supportno" },
        { title: "Line ID", key: "lineid" },
        { title: "Line Add URL", key: "lineaddurl" },
        { title: "Facebook Page Username", key: "fbpage" },
        { title: "Google Analytics ID", key: "gaid" },
        { title: "Facebook Pixel ID", key: "fbpid" },
        { title: "Intro", key: "" },
        { title: "Promotion Text", key: "" },
        { title: "Instruction", key: "instruction", type: "html" },
        { title: "Withholding Tax", key: "wht_status" },
        { title: "Withholding Tax %", key: "wht_vat" },
        { title: "Allow Tax Invoice", key: "" },
        { title: "Sell Start Date", key: "selldate_start" },
        { title: "Sell End Date", key: "selldate_end" },
        { title: "Sold Out", key: "" },
        { title: "Zoom Status", key: "zoom_status" },
        { title: "Zoom Webinar ID", key: "zoom_webinar_id" },
        { title: "Free Code", key: "" },
        { title: "More Than One Ticket Price", key: "" },
        { title: "Hide Discount", key: "" },
        { title: "Fields", key: "fields_status" },
        { title: "Update Date", key: "" },
        { title: "Cache (Product)", key: "" }
      ],
      sellerData: [
        { title: "Logo", key: "logo", type: "image" },
        { title: "Merchant ID", key: "merchant_id" },
        { title: "Business", key: "name" },
        { title: "Email Sender", key: "emailfromname" },
        { title: "Email", key: "emailfromemail" },
        { title: "Short URL", key: "shorturl" },
        { title: "SMS Sender", key: "smssender" },
        { title: "Bank A/c 1", key: "bank1" },
        { title: "Bank A/c Name", key: "bankaccname1" },
        { title: "Bank A/c No.", key: "bankaccno1" },
        { title: "Bank A/c 2", key: "bank2" },
        { title: "Bank A/c Name", key: "bankaccname2" },
        { title: "Bank A/c No.", key: "bankaccno2" },
        { title: "Google Analytics ID", key: "gaid" },
        { title: "Update Date (Merchant)", key: "update_date" },
        { title: "Merchant Cache", key: "" }
      ],
      productData: [
        { title: "Sell Status", key: "sell_status" },
        { title: "Product ID", key: "product_id" },
        { title: "Event ID", key: "" },
        { title: "Name", key: "pro_name" },
        { title: "Short Name", key: "pro_shortname" },
        { title: "Short Description", key: "pro_shortdesc" },
        { title: "Long Description", key: "pro_longdesc" },
        { title: "Poster", key: "poster", type: "image" },
        { title: "Type", key: "pro_type" },
        { title: "Quantity", key: "Quantity" },
        { title: "Sold", key: "" },
        { title: "Remaining", key: "" },
        { title: "Ticket Price", key: "fullprice" },
        { title: "Full Price", key: "fullprice" },
        { title: "Early Bird Price", key: "ebprice" },
        { title: "Early Bird Deadline", key: "ebdeadline" },
        { title: "Current Price", key: "current_price" },
        { title: "Promo Prices", key: "promo_price" },
        { title: "Quantity per Pack", key: "" },
        { title: "Promo Text", key: "" },
        { title: "Sell Start", key: "selldate_start" },
        { title: "Sell End", key: "selldate_end" },
        { title: "Sold Out", key: "soldout" },
        { title: "Promo Code Code 1", key: "pccode1" },
        { title: "Promo Code Discount Value1", key: "pcdisclevel1" },
        { title: "Promo Code Discount Type1", key: "pcdisctype1" },
        { title: "Promo Code Code 2", key: "pccode2" },
        { title: "Promo Code Discount Value2", key: "pcdisclevel2" },
        { title: "Promo Code Discount Type2", key: "pcdisctype2" },
        { title: "Promo Code Code 3", key: "pccode3" },
        { title: "Promo Code Discount Value3", key: "pcdisclevel3" },
        { title: "Promo Code Discount Type3", key: "pcdisctype3" },
        { title: "Free Code", key: "" },
        { title: "Price for 2+ quantity", key: "" },
        { title: "Update Date", key: "update_date" }
      ]
    };
  },
  created() {
    this.loadEvent();
  },
  methods: {
    loadEvent() {
      // let data = {
      //   e: this.$route.query.e,
      //   s: this.$route.query.s
      // };
      /*
      let params = Object.keys(data)
        .map((key) => key + "=" + data[key])
        .join("&");
        */
      Service.Event.get(this.folder)
        .then(res => {
          this.event = res.data.event;
          this.merchant = res.data.event.merchant;
          this.event.selldate_start = moment.utc(res.data.event.selldate_start).tz(this.event.timezone).format("YYYY-MM-DD HH:mm:ss")
          this.event.selldate_end = moment.utc(res.data.event.selldate_end).tz(this.event.timezone).format("YYYY-MM-DD HH:mm:ss")

          this.event_url =
            "https://" +
            this.event.merchant.domain +
            "/" +
            this.event.slug +
            "/register";

          Service.Event.getProducts(this.folder).then(res => {
            this.products = res.data.items;
          });
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.flex-table {
  display: flex !important;
}
</style>
